export const HERO_CONSTANTS = {
  button: {
    label: "Unlock Your Infrastructure. Unleash Your Potential. ",
    link: "#contact-us",
  },
  content: "Seamless Cloud Migrations Powered by OneMind Expertise & Automation ",
  title: "From VMware. From Nutanix. From Anywhere. ",
};
